import { useAuth } from '../context/AuthContext'

// Component to conditionally render content based on roles
export const RoleBasedAccess = ({
  allowedRoles = [],
  children,
  fallback = null,
  requireAll = false, // If true, user must have ALL roles; if false, ANY role
}) => {
  const { user, hasRole, hasAnyRole, isAuthenticated } = useAuth()

  // if (!user || !allowedRoles.length) {
  //   return fallback
  // }
if (!isAuthenticated) {
  return fallback
}
if (!allowedRoles.length) {
  return children // No restrictions
}
  const hasAccess = requireAll
    ? allowedRoles.every((role) => hasRole(role))
    : hasAnyRole(allowedRoles)

  return hasAccess ? children : fallback
}

// HOC for protecting entire components
export const withRoleAccess = (WrappedComponent, allowedRoles = []) => {
  return function RoleProtectedComponent(props) {
    return (
      <RoleBasedAccess
        allowedRoles={allowedRoles}
        fallback={
          <div
            style={{
              padding: '20px',
              textAlign: 'center',
              color: '#666',
            }}
          >
            You don't have permission to access this content.
          </div>
        }
      >
        <WrappedComponent {...props} />
      </RoleBasedAccess>
    )
  }
}

// Hook for role-based logic in components
export const useRoleAccess = () => {
  const {
    hasRole,
    hasAnyRole,
    isAdmin,
    // isModerator,
    // isPremium
  } = useAuth()

  return {
    hasRole,
    hasAnyRole,
    isAdmin: isAdmin(),
    // isModerator: isModerator(),
    // isPremium: isPremium(),
    canDelete: hasAnyRole(['ADMIN', 'MODERATOR']),
    canEdit: hasAnyRole(['ADMIN', 'EDITOR', 'MODERATOR']),
    canAccessPremium: hasAnyRole(['ADMIN', 'PREMIUM']),
  }
}

// Usage examples

// Multiple roles
{/* <RoleBasedAccess allowedRoles={['ADMIN', 'MODERATOR']}>
  <ModeratorFeatures />
</RoleBasedAccess> */}

// Require all roles
{/* <RoleBasedAccess 
  allowedRoles={['ADMIN', 'PREMIUM']} 
  requireAll={true}
>
  <PremiumAdminFeatures />
</RoleBasedAccess> */}